import { ComponentThemeType } from '@/cl/theme/theme.hooks';

export const LabelCopyComponentTheme: ComponentThemeType<{ align: 'center' | 'left' }> = (_theme, { align }) => ({
  baseStyle: {
    container: {
      display: 'flex',
      alignItems: 'center',
      borderRadius: 'm',
      p: 2,
      gridGap: '16px',
    },
    link: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },
  variants: {
    button: {
      container: {
        justifyContent: 'space-between',
      },
    },
    icon: {
      container: {
        justifyContent: align === 'left' ? 'flex-start' : 'center',
      },
    },
  },
});
